import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'; // further imports omitted
import { Row, Col, Card } from 'react-bootstrap';
import { PlusCircle, CloudDownload, FolderOpen } from 'lucide-react';
import { createProject, importProject, setTemporaryProject } from '../../../actions';
import moment from 'moment';
import { Trans } from 'react-i18next';

class ChooseProject extends React.Component {

    constructor() {

        super();

        this.onChangeFile = this.onChangeFile.bind(this);
        this.createProject = this.createProject.bind(this);
    }

    createProject() {
        const timeStamp = moment().unix();
        const temporaryProject = {
            name: 'temporaryProject_' + timeStamp,
            orderCode: '',
            customer: '',
            description: '',
        };

        this.props.createProject(temporaryProject)
            .then(() => {

                //used by Project to know that this project is not saved yet
                this.props.setTemporaryProject(true);

                this.props.history.push('/projects/' + this.props.project.id + '/driver');
                //this.props.history.go('/projects/' + this.props.project.id + '/driver');
            });
    }

    onChangeFile(e) {

        const files = Array.from(e.target.files);

        if (files.length !== 1) {
            return;
        }

        this.props.importProject(files[0])
            .then(() => {
                this.props.history.push('/projects/' + this.props.project.id + '/driver', { state: this.state });
                this.props.history.go('/projects/' + this.props.project.id + '/driver');
            })
            .catch(() => {
                document.getElementById("inputFile").value = null;
            });
    }

    openFileDialog() {
        document.getElementById("inputFile").click();
    }

    render() {
        return (
            <Card className="card-choose-project">
                <div className='card-header-choose-project'>
                    <h6 style={{ marginBottom: '0' }}><Trans i18nKey="Luminaire_Configurator" /></h6>
                </div>
                <Card.Body style={{ padding: '0' }}>
                    <Row className='card-row-up-choose-project'>
                        <Col>
                            <div className="a-welcome" onClick={this.createProject}>
                                <PlusCircle style={{ color: 'rgba(0, 0, 0, 0.54)' }} size="4rem" />
                                <br />
                                <Trans i18nKey="Create_New_Project" />
                            </div>
                            {/* <Link to={`/projectNew`} className="a-welcome">
                                <FontAwesomeIcon color='action' size='5x' icon={faPlusCircle} />
                                <br />
                                Create New Project
                            </Link> */}
                        </Col>
                    </Row>
                    <Row className='card-row-down-choose-project'>
                        <Col sm="6" style={{ borderRight: "1px solid rgba(0,0,0,.125)" }}>
                            <div className="a-welcome" onClick={this.openFileDialog}>
                                <FolderOpen style={{ color: 'rgba(0, 0, 0, 0.54)' }} size="4rem" />
                                <br />
                                <Trans i18nKey="Open_file" /> <br /> <Trans i18nKey="from_computer" />
                                <input type='file' accept='.osrtup, .osrtur, .osrtul' id="inputFile" onChange={this.onChangeFile} hidden />
                            </div>
                        </Col>
                        <Col sm="6">
                            <Link to={`/projects`} className="a-welcome">
                                <CloudDownload style={{ color: 'rgba(0, 0, 0, 0.54)' }} size="4rem" />
                                <br />
                                <Trans i18nKey="Open_project" /> <br /> <Trans i18nKey="from_cloud" />
                            </Link>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        project: state.project.info
    };
};

const mapDispatchToProps = {
    createProject,
    importProject,
    setTemporaryProject,
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ChooseProject));
